"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LabelValueDisplay = _interopRequireDefault(require("01_core/components/layout/LabelValueDisplay"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 訓練基本情報欄
 * @prop {object} [data] - 訓練基本情報
 * @prop {string} [data.kunrenNm] - 訓練名
 * @prop {string} [data.bcmKaishaSoshikiNm] - 会社／組織
 * @prop {string} [data.bcpTgtJigyoNm] - BCP対象事業
 * @prop {bool} hiddenFlg - 非表示フラグ
 */
const KunrenInfoField = props => {
  const {
    intl,
    data = {
      kunrenNm: '',
      bcmKaishaSoshikiNm: '',
      bcpTgtJigyoNm: ''
    },
    hiddenFlg = false
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TRAINING_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(data.kunrenNm)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
    }),
    value: _stringUtil.default.emptyToHyphen(data.bcmKaishaSoshikiNm)
  })), hiddenFlg !== true && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_BCP_TGT_JIGYO
    }),
    value: _stringUtil.default.emptyToHyphen(data.bcpTgtJigyoNm)
  }))));
};
KunrenInfoField.propTypes = {
  data: _propTypes.default.shape({
    kunrenNm: _propTypes.default.string,
    bcmKaishaSoshikiNm: _propTypes.default.string,
    bcpTgtJigyoNm: _propTypes.default.string
  })
};
var _default = exports.default = (0, _reactIntl.injectIntl)(KunrenInfoField);